// extracted by mini-css-extract-plugin
export default {"container":"SubCard_container__jU-rn","heading":"SubCard_heading__+Ju9D","subheading":"SubCard_subheading__QKpZd"};